var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C10.866 14.5 14 11.366 14 7.5C14 3.63401 10.866 0.5 7 0.5C3.13401 0.5 0 3.63401 0 7.5C0 11.366 3.13401 14.5 7 14.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43491 7.49979C9.43491 8.10849 8.34482 9.63022 7.00014 9.63022C5.65545 9.63022 4.56537 8.10849 4.56537 7.49979C4.56537 6.15508 5.65545 5.06502 7.00014 5.06502C8.34482 5.06502 9.43491 6.15508 9.43491 7.49979Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43491 7.49973C9.43491 8.84444 8.34482 9.9345 7.00014 9.9345C5.65545 9.9345 4.56537 8.84444 4.56537 7.49973",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2279 9.00652L9.58234 9.65213L10.0127 10.0825L10.6584 9.43693L10.2279 9.00652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15159 10.0823L8.50598 10.7279L8.93639 11.1583L9.582 10.5127L9.15159 10.0823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5191 10.2969L10.8735 10.9425L11.3039 11.3729L11.9496 10.7273L11.5191 10.2969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4435 11.3739L9.79785 12.0195L10.2283 12.4499L10.8739 11.8043L10.4435 11.3739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8737 9.65229L10.2281 10.2979L10.6585 10.7283L11.3041 10.0827L10.8737 9.65229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79765 10.7281L9.15204 11.3737L9.58245 11.8041L10.2281 11.1585L9.79765 10.7281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15209 3.62559L10.8737 5.34721L11.3041 4.9168L9.5825 3.19518L9.15209 3.62559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50661 4.27193L9.15222 4.91754L9.58261 4.48715L8.93701 3.84154L8.50661 4.27193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58267 5.3475L10.2283 5.9931L10.6587 5.56271L10.0131 4.91711L9.58267 5.3475Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79714 2.98049L10.4427 3.6261L10.8732 3.19569L10.2276 2.55008L9.79714 2.98049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8739 4.05698L11.5195 4.70259L11.9499 4.27218L11.3043 3.62657L10.8739 4.05698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20197 12.0196L2.48035 10.298L2.04994 10.7284L3.77156 12.45L4.20197 12.0196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84788 11.3733L4.20227 10.7277L3.77188 11.1581L4.41749 11.8037L4.84788 11.3733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77177 10.2976L3.12616 9.65201L2.69575 10.0824L3.34136 10.728L3.77177 10.2976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49354 10.728L3.77191 9.00635L3.3415 9.43676L5.06313 11.1584L5.49354 10.728Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48071 4.70275L4.20233 2.98112L3.77192 2.55071L2.05029 4.27234L2.48071 4.70275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12585 5.34739L4.84747 3.62576L4.41706 3.19535L2.69543 4.91698L3.12585 5.34739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77203 5.99328L5.49365 4.27165L5.06326 3.84126L3.34163 5.56289L3.77203 5.99328Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.716fecb07d57f56b022735d380474ed4.svg";
export { ForwardRef as ReactComponent };